// 各種製品マニュアル
import ProductManuals from '../pages/productManuals/ProductManuals.vue';

export default [
  {
    // 各種製品マニュアル
    path: '/product_manuals',
    name: 'ProductManuals',
    component: ProductManuals,
    meta: {
      title: '各種製品マニュアル - desknet\'s NEO | ChatLuck クラウド版サポートサイト',
    },
    props: true
  },
]